<template>
  <div>
    <vx-card class="mb-5" title="Learning & Resources">
      <p class="mb-5">
        According to IGEA, the Australian games development industry is now worth $184.6 million,
        with the potential to grow even further in 2021.
      </p>
      <p class="mb-5">
        <a href="" target="_blank">IGEA</a> (<strong
          >Interactive Games & Entertainment Association</strong
        >) is the peak industry association representing the voice of Australian and New Zealand
        companies in the computer and video games industry.
      </p>
      <p class="mb-5">
        The below videos are for you to get a general idea of the Gaming Industry and the different
        developer and designer roles, so that you can consider which direction might be best for
        you. It is not a test and you do not need to understand everything. Just enjoy building your
        knowledge on an area that is of interest to you.
      </p>
      <p class="mb-5 text-bold">Why do Australians play video games?</p>

      <responsive-youtube-wrapper :video="videos[1].video" :image="videos[1].image" />

      <p class="mb-5 text-bold">Should I learn to code or learn game design?</p>
      <div class="vx-row flex items-center justify-center">
        <div class="vx-col xl:w-2/3 lg:w-1/2 w-full my-5">
          <responsive-iframe-youtube :src="videos[2].video" :posterimg="videos[2].image" />
        </div>
        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full my-5">
          <a :href="'content/gamesdeveloper/programming_or_design.pdf' | blob_url" target="_blank">
            <img
              :src="image1"
              alt="Read 'Programming or design?' (PDF, opens in a new tab)"
              class="mx-auto img-responsive"
            />
          </a>
        </div>
      </div>

      <p class="mb-5 text-bold">How to become a Game Designer:</p>
      <div class="vx-row flex items-center justify-center">
        <div class="vx-col xl:w-2/3 lg:w-1/2 w-full my-5">
          <div class="vx-row">
            <div class="vx-col w-full mb-2 r">
              <responsive-iframe-youtube :src="videos[3].video" :posterimg="videos[3].image" />
            </div>
            <div class="vx-col w-full mb-2">
              <responsive-iframe-youtube :src="videos[4].video" :posterimg="videos[4].image" />
            </div>
          </div>
        </div>
        <div class="vx-col xl:w-1/3 lg:w-1/2 w-full my-5">
          <a
            :href="'content/gamesdeveloper/how_to_become_a_game_designer.pdf' | blob_url"
            target="_blank"
          >
            <img
              :src="image2"
              alt="Read 'How to become a game designer' (PDF, opens in a new tab)"
              class="mx-auto img-responsive"
            />
          </a>
        </div>
      </div>

      <p class="mb-5 text-bold">How to program:</p>
      <responsive-youtube-wrapper :video="videos[5].video" :image="videos[5].image" />

      <p class="mb-5 text-bold">How to get into the games industry - A recruiter's top 5 tips:</p>
      <responsive-youtube-wrapper :video="videos[6].video" :image="videos[6].image" />
    </vx-card>
  </div>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      videos: {
        1: {
          video: 'https://www.youtube.com/embed/_LkOFWvDPlA',
          image: require('@/assets/images/experiences/gamesdeveloper/why_australians_play_video_games_splash.jpg'),
        },
        2: {
          video: 'https://www.youtube.com/embed/_7qgvNOTfdQ',
          image: require('@/assets/images/experiences/gamesdeveloper/code_or_game_design_splash.jpg'),
        },
        3: {
          video: 'https://www.youtube.com/embed/PMXf0e8n2Oc',
          image: require('@/assets/images/experiences/gamesdeveloper/become_a_game_designer_splash.jpg'),
        },
        4: {
          video: 'https://www.youtube.com/embed/6vSucvjN9Tc',
          image: require('@/assets/images/experiences/gamesdeveloper/become_a_video_game_designer_splash.jpg'),
        },
        5: {
          video: 'https://www.youtube.com/embed/N775KsWQVkw',
          image: require('@/assets/images/experiences/gamesdeveloper/how_to_program_splash.jpg'),
        },
        6: {
          video: 'https://www.youtube.com/embed/NNOw7_e372E',
          image: require('@/assets/images/experiences/gamesdeveloper/get_into_game_industry_splash.jpg'),
        },
      },
      image1: require('@/assets/images/experiences/gamesdeveloper/programming_or_design_sheet_button.png'),
      image2: require('@/assets/images/experiences/gamesdeveloper/how_to_bcome_a_designer_sheet_button.png'),
    };
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.activeExperienceID);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
  },
  beforeMount() {
    store.commit('authStudent/setActiveExperienceID', this.$route.params.id);
  },
};
</script>
